// extracted by mini-css-extract-plugin
module.exports = {"lia-dropdown-menu":"CategoryActionMenu_lia-dropdown-menu__q_Wdo"};